import React from 'react';
import MapView from '../MapView';
import { isSecureGeolocationContext, getGeolocationHttpsHint } from '../../utils/secureContext';

export default function CoordinateToolMapPane({
  isMobile,
  isFullScreen,
  mapType,
  setMapType,
  mapCenter,
  mapMarker,
  setMapCenter,
  setMapMarker,
  handleFullScreen
}) {
  return (
    <div style={{
      flex: isMobile ? '1 1 auto' : '2.6 1 420px',
      minWidth: isMobile ? '100%' : 360,
      minHeight: isMobile ? 300 : 500,
      height: isMobile ? '50vh' : '100%',
      width: '100%',
      position: 'relative'
    }} className="map-container">
      <h4>地图预览</h4>
      <div style={{
        height: isFullScreen ? '80vh' : (isMobile ? 280 : 480),
        border: '1px solid #ccc',
        width: '100%',
        borderRadius: '4px',
        position: 'relative'
      }}>
        <div style={{
          position: 'absolute',
          top: 10,
          left: 10,
          zIndex: 20,
          display: 'flex',
          gap: 4,
          background: 'rgba(255, 255, 255, 0.95)',
          borderRadius: 6,
          padding: 4,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>
          <button
            onClick={() => setMapType('mapbox')}
            style={{
              padding: '6px 10px',
              background: mapType === 'mapbox' ? '#1976d2' : '#fff',
              color: mapType === 'mapbox' ? '#fff' : '#333',
              border: '1px solid #1976d2',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            街道
          </button>
          <button
            onClick={() => setMapType('satellite')}
            style={{
              padding: '6px 10px',
              background: mapType === 'satellite' ? '#1976d2' : '#fff',
              color: mapType === 'satellite' ? '#fff' : '#333',
              border: '1px solid #1976d2',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            卫星
          </button>
          <button
            onClick={() => setMapType('satelliteStreets')}
            style={{
              padding: '6px 10px',
              background: mapType === 'satelliteStreets' ? '#1976d2' : '#fff',
              color: mapType === 'satelliteStreets' ? '#fff' : '#333',
              border: '1px solid #1976d2',
              borderRadius: 4,
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            卫星+道路
          </button>
        </div>

        <MapView mapType={mapType} center={mapCenter} zoom={15} marker={mapMarker} />

        <button
          onClick={() => {
            if (!navigator.geolocation) {
              alert('您的浏览器不支持地理定位功能');
              return;
            }

            if (!isSecureGeolocationContext()) {
              alert(getGeolocationHttpsHint());
              return;
            }

            if (navigator.permissions && navigator.permissions.query) {
              navigator.permissions.query({ name: 'geolocation' }).then((permissionStatus) => {
                console.log('地理位置权限状态:', permissionStatus.state);

                if (permissionStatus.state === 'denied') {
                  alert('地理位置权限已被拒绝，请在浏览器设置中允许位置访问，然后刷新页面');
                  return;
                }

                getCurrentLocation();
              });
            } else {
              getCurrentLocation();
            }

            function getCurrentLocation() {
              console.log('开始获取当前位置...');

              navigator.geolocation.getCurrentPosition(
                (position) => {
                  const { longitude, latitude, accuracy } = position.coords;
                  console.log('获取位置成功:', { longitude, latitude, accuracy });

                  setMapCenter([longitude, latitude]);
                  setMapMarker({ lng: longitude, lat: latitude });

                  console.log('更新地图中心到当前位置:', [longitude, latitude]);

                  alert(`定位成功！\n经度: ${longitude.toFixed(6)}\n纬度: ${latitude.toFixed(6)}\n精度: ${accuracy ? accuracy.toFixed(1) + '米' : '未知'}`);
                },
                (error) => {
                  console.error('获取当前位置失败:', error);
                  let errorMessage = '无法获取当前位置';

                  switch (error.code) {
                    case error.PERMISSION_DENIED:
                      errorMessage = '位置权限被拒绝，请在浏览器设置中允许位置访问';
                      break;
                    case error.POSITION_UNAVAILABLE:
                      errorMessage = '位置信息不可用，请检查GPS是否开启';
                      break;
                    case error.TIMEOUT:
                      errorMessage = '获取位置超时，请重试';
                      break;
                    default:
                      errorMessage = '获取位置时发生未知错误';
                  }

                  alert(errorMessage);
                },
                {
                  enableHighAccuracy: true,
                  timeout: 15000,
                  maximumAge: 60000
                }
              );
            }
          }}
          style={{
            position: 'absolute',
            left: 10,
            bottom: 10,
            width: 48,
            height: 48,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.95)',
            border: '2px solid #1976d2',
            color: '#1976d2',
            fontSize: 20,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            transition: 'all 0.2s ease',
            zIndex: 21
          }}
          onMouseEnter={(e) => {
            e.target.style.background = '#1976d2';
            e.target.style.color = '#fff';
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = 'rgba(255,255,255,0.95)';
            e.target.style.color = '#1976d2';
            e.target.style.transform = 'scale(1)';
          }}
          title="定位到当前设备位置"
        >
          📍
        </button>

        <button
          onClick={handleFullScreen}
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            zIndex: 10,
            padding: '6px 14px',
            borderRadius: 6,
            background: '#1976d2',
            color: '#fff',
            border: 'none',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
            fontSize: '12px'
          }}
        >
          {isFullScreen ? '退出全屏' : '全屏'}
        </button>
      </div>
    </div>
  );
}
